import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  country: string;
  constructor(
    // private route: ActivatedRoute,
    // private sharedService: SharedService,
    // public dialog: MatDialog,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService

  ) {
  }
  email: any;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../assets/js/owl.carousel.min.js', function () {
        $.getScript('../../../assets/js/home_client_slider.js', function () { });
       });
    }
    this.titleService.setTitle('Verificador gramatical avançado para escrita acadêmica e profissional - Trinka');
    this.metaTagService.updateTag({ name: 'description', content: "Use a Trinka para encontrar erros exclusivos da escrita acadêmica que outras ferramentas simplesmente não conseguem. De erros gramaticais complexos ao tom e estilo científico, a Trinka corrige todos eles!" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Ferramenta de verificação de gramática Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'A Trinka é a melhor ferramenta de correção de gramática e linguagem IA para redação acadêmica e técnica.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai' });
  }
  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('main_header').classList.remove('homepageHeader');
    }
  }

  
}
